import DataTable from "../../../Components/DataTable/DataTable";
import { PercentageOutlined, LinkOutlined } from "@ant-design/icons";
import { useEffect, useState, useCallback } from "react";
import * as actions from "../../../store/actions/action";
import api from "../../../api/api";
import { connect } from "react-redux";
import { Input, Tag, message, Button, Select } from "antd";
import CheckPermission from "../../../Util/CheckPermission";
import { useNavigate } from "react-router-dom";
import { editError } from "../../../Util/Messages";
import { toJalaali } from "jalaali-js";
import DatePicker from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import jalali from "react-date-object/calendars/jalali";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";

const MAX_TEXT_LEN_IN_TABLE = 30;

const OrderDiscount = ({
  rowSelection,
  LoadingSetter,
  ClearLoading,
  loading,
  ClearError,
  ErrorSetter,
  permissions,
}) => {
  const [data, setData] = useState([]);
  const [products, setProducts] = useState([]);
  const [startDateCleared, setStartDateCleared] = useState();
  const [endDateCleared, setEndDateCleared] = useState();

  const navigate = useNavigate();

    const loadProducts = () => {
    LoadingSetter();
    api
      .get("/product/admin")
      .then((res) => setProducts(res.data))
      .catch((err) => {
        alert('خطا در دریافت لیست محصولات')
      })
      .finally(() => ClearLoading());
  };

  useEffect(() => {
    loadProducts()
  }, [])
  
  const columns = [
    // code
    {
      title: "کد تخفیف",
      dataIndex: "code",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) return <Input placeholder="کد تخفیف" />;
      },
    },

    // discount_type
    {
      title: "نوع تخفیف",
      dataIndex: "discount_type",
      align: "center",
      editable: false,
      filters: [
        { text: "مبلغ ثابت", value: 1 },
        { text: "درصدی", value: 2 },
      ],
      onFilter: (val, record) => record.discount_type === val,
      render: (type) => {
        if (type === 1) return <Tag color="blue">مبلغ ثابت</Tag>;
        if (type === 2) return <Tag color="green">درصدی</Tag>;
        return <Tag color="red">ندارد</Tag>;
      },
    },

    // product
    {
      title: "محصول",
      dataIndex: "productId",
      align: "center",
      filters: products.map((el) => ( { text: el.privateTitle, value: el.id })),
      onFilter: (val, rec) => val === rec?.productId,
      render: (val, rec) => products.find((e)=> e.id === val)?.privateTitle,
      renderFormItem: (_, { isEditable, record }) => {
        if (!isEditable) return '-'
        return (
          <Select
            allowClear
            style={{ width: "100%" }}
            placeholder="انتخاب کنید"
            options={products.map((el) => ({ label: el.privateTitle, value: el.id }))}
            value={record.productId}
          />
  )
}
    },
    // amount (for discount_type = 1)
    {
      title: "مبلغ تخفیف",
      dataIndex: "amount",
      align: "center",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Input
              type="number"
              placeholder="مبلغ تخفیف (برای نوع مبلغ ثابت)"
              disabled={record?.discount_type === 2}
            />
          );
        }
      },
      render: (_, record) => {
        if (record.discount_type !== 1 || !record.amount) {
          return <Tag color="red">ندارد</Tag>;
        }
        return `${record.amount.toLocaleString()} تومان`;
      },
    },
    // percent (for discount_type = 2)
    {
      title: "درصد تخفیف",
      dataIndex: "percent",
      align: "center",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Input
              type="number"
              placeholder="درصد تخفیف (برای نوع درصدی)"
              disabled={record?.discount_type === 1}
            />
          );
        }
      },
      render: (_, record) => {
        if (record.discount_type !== 2 || !record.percent) {
          return <Tag color="red">ندارد</Tag>;
        }
        return `${record.percent}%`;
      },
    },

    // startdate
    {
      title: "تاریخ شروع",
      align: "center",
      dataIndex: "startdate",
      sorter: (a, b) => {
        try {
          const Adate = new Date(a.startdate);
          const Bdate = new Date(b.startdate);
          return Bdate - Adate;
        } catch (error) {
          return 0;
        }
      },
      render: (_, record) => {
        if (!record.startdate || typeof record.startdate !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }

        const date = new Date(record.startdate);
        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
            {date.toLocaleTimeString("fa-IR", { hour12: false })}
          </span>
        );
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <DatePicker
              format="YYYY/MM/DD HH:mm:ss"
              calendar={jalali}
              locale={persian_fa}
              render={(value, openCalendar) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    {record.id !== startDateCleared && (
                      <Input value={value} onClick={openCalendar} />
                    )}

                    {record.id !== startDateCleared ? (
                      <ClearIcon
                        onClick={() => setStartDateCleared(record.id)}
                        fontSize="small"
                      />
                    ) : (
                      <AddIcon
                        onClick={() => setStartDateCleared()}
                        fontSize="small"
                      />
                    )}
                  </div>
                );
              }}
            />
          );
        }
      },
    },
    // enddate
    {
      title: "تاریخ پایان",
      align: "center",
      dataIndex: "enddate",
      sorter: (a, b) => {
        try {
          const Adate = new Date(a.enddate);
          const Bdate = new Date(b.enddate);
          return Bdate - Adate;
        } catch (error) {
          return 0;
        }
      },
      render: (_, record) => {
        if (!record.enddate || typeof record.enddate !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }

        const date = new Date(record.enddate);
        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
            {date.toLocaleTimeString("fa-IR", { hour12: false })}
          </span>
        );
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <DatePicker
              format="YYYY/MM/DD HH:mm:ss"
              calendar={jalali}
              locale={persian_fa}
              render={(value, openCalendar) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    {record.id !== endDateCleared && (
                      <Input value={value} onClick={openCalendar} />
                    )}

                    {record.id !== endDateCleared ? (
                      <ClearIcon
                        onClick={() => setEndDateCleared(record.id)}
                        fontSize="small"
                      />
                    ) : (
                      <AddIcon
                        onClick={() => setEndDateCleared()}
                        fontSize="small"
                      />
                    )}
                  </div>
                );
              }}
            />
          );
        }
      },
    },
    // total_count
    {
      title: "تعداد کل",
      dataIndex: "total_count",
      align: "center",
      sorter: (a, b) => {
        const Acount = a.total_count ?? 10 ** 5;
        const Bcount = b.total_count ?? 10 ** 5;
        return Bcount - Acount;
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable)
          return (
            <Input
              type="number"
              placeholder="تعداد کل استفاده (خالی = نامحدود)"
            />
          );
      },
      render: (_, record) => {
        if (typeof record.total_count !== "number") {
          return <Tag color="orange">نامحدود</Tag>;
        }
        return record.total_count.toLocaleString();
      },
    },
    // remains
    {
      title: "باقیمانده",
      dataIndex: "remains",
      align: "center",
      editable: false,
      sorter: (a, b) => {
        const Aremains = a.remains ?? 10 ** 5;
        const Bremains = b.remains ?? 10 ** 5;
        return Bremains - Aremains;
      },
      render: (_, record) => {
        if (typeof record.remains !== "number") {
          return <Tag color="orange">نامحدود</Tag>;
        }
        return (
          <Tag color={record.remains > 0 ? "green" : "red"}>
            {record.remains.toLocaleString()}
          </Tag>
        );
      },
    },
    // description
    {
      title: "توضیحات",
      dataIndex: "description",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return <Input.TextArea rows={3} placeholder="توضیحات" />;
        }
      },
      render: (_, record) => {
        if (!record.description || typeof record.description !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }

        return record.description.length > MAX_TEXT_LEN_IN_TABLE
          ? `${record.description.substring(0, MAX_TEXT_LEN_IN_TABLE)}...`
          : record.description;
      },
    },
    // user_message
    {
      title: "پیام کاربر",
      dataIndex: "user_message",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Input.TextArea
              rows={3}
              placeholder="پیام نمایش داده شده هنگام اعمال تخفیف"
            />
          );
        }
      },
      render: (_, record) => {
        if (!record.user_message || typeof record.user_message !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }

        return record.user_message.length > MAX_TEXT_LEN_IN_TABLE
          ? `${record.user_message.substring(0, MAX_TEXT_LEN_IN_TABLE)}...`
          : record.user_message;
      },
    },
    // end_message
    {
      title: "پیام پایان",
      dataIndex: "end_message",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Input.TextArea
              rows={3}
              placeholder="پیام نمایش داده شده هنگام انقضا یا تمام شدن"
            />
          );
        }
      },
      render: (_, record) => {
        if (!record.end_message || typeof record.end_message !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }

        return record.end_message.length > MAX_TEXT_LEN_IN_TABLE
          ? `${record.end_message.substring(0, MAX_TEXT_LEN_IN_TABLE)}...`
          : record.end_message;
      },
    },
    // link
    {
      title: "لینک",
      dataIndex: "link",
      align: "center",
      editable: false,
      render: (_, record) => {
        const handleCopyLink = () => {
          const baseUrl =
            process.env.REACT_APP_FRONTEND_BASEURL || "planium.ir";
          const baseUrlWithProtocol = baseUrl.startsWith("http")
            ? baseUrl
            : `https://${baseUrl}`;
          const urlObj = new URL("/app", baseUrlWithProtocol);
          urlObj.searchParams.set("dcode", record.code);
          const url = urlObj.toString();
          navigator.clipboard
            .writeText(url)
            .then(() => {
              message.success("لینک با موفقیت کپی شد");
            })
            .catch(() => {
              message.error("خطا در کپی لینک");
            });
        };
        return (
          <Button
            icon={<LinkOutlined />}
            onClick={handleCopyLink}
            style={{ borderColor: "#d9d9d9" }}
          />
        );
      },
    },
    // created at
    {
      title: "تاریخ ساخت",
      align: "center",
      dataIndex: "createdAt",
      editable: false,
      sorter: (a, b) => {
        const Adate = new Date(a.createdAt);
        const Bdate = new Date(b.createdAt);
        return Bdate - Adate;
      },
      render: (_, record) => {
        if (!record.createdAt || typeof record.createdAt !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }
        const date = record.createdAt ? new Date(record.createdAt) : new Date();
        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
            {date.toLocaleTimeString("fa-IR", { hour12: false })}
          </span>
        );
      },
    },
  ];

  const loadData = useCallback(() => {
    LoadingSetter();
    api
      .get("/discounts")
      .then((res) => {
        // Handle pagination response structure
        const responseData = res.data?.data || res.data || [];
        setData(Array.isArray(responseData) ? responseData : []);
      })
      .catch((err) => {
        console.error("Failed to load discounts:", err);
        editError();
      })
      .finally(() => ClearLoading());
  }, [LoadingSetter, ClearLoading]);

  useEffect(() => {
    if (
      permissions !== null &&
      CheckPermission("external_discount_list", permissions) === false
    ) {
      navigate("/permissionDenied");
    }
  }, [permissions, navigate]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const onSave = (row, rowData) => {
    LoadingSetter();

    let oldData = null;
    data.forEach((item) => {
      if (item.id === row.id) oldData = item;
    });

    if (oldData === null) {
      // Create new discount - include all fields
      const apiData = {
        code: rowData.code,
        discount_type: rowData.discount_type || 1,
        startdate: rowData?.startdate?.toDate(),
        enddate: rowData?.enddate?.toDate(),
        total_count: rowData.total_count ? +rowData.total_count : undefined,
        product: rowData.productId ? {id:+rowData.productId} : undefined,
        description: rowData?.description,
        user_message: rowData?.user_message,
        end_message: rowData?.end_message,
      };

      // Add amount or percent based on discount_type
      if (apiData.discount_type === 1) {
        apiData.amount = rowData.amount ? +rowData.amount : undefined;
        apiData.percent = undefined;
      } else if (apiData.discount_type === 2) {
        apiData.percent = rowData.percent ? +rowData.percent : undefined;
        apiData.amount = undefined;
      }

      api
        .post("/discounts", apiData)
        .then(() => {
          message.success("کد تخفیف با موفقیت ایجاد شد");
          ClearLoading();
          loadData();
        })
        .catch((err) => {
          ClearLoading();
          message.error(err.response.data.error.message);
        });
    } else {
      // Update existing discount - only include changed fields
      const apiData = {};

      // Only include fields that are actually being changed
      if (rowData.code !== undefined) apiData.code = rowData.code;
      if (rowData.discount_type !== undefined)
        apiData.discount_type = rowData.discount_type || 1;
      // Handle dates - check if date was cleared
      if (startDateCleared === oldData.id) {
        // Date was cleared, set to null
        apiData.startdate = null;
      } else if (rowData.startdate !== undefined) {
        // Date was changed, include new value
        apiData.startdate =
          typeof rowData?.startdate === "string"
            ? rowData?.startdate
            : rowData?.startdate?.toDate();
      }
      if (endDateCleared === oldData.id) {
        // Date was cleared, set to null
        apiData.enddate = null;
      } else if (rowData.enddate !== undefined) {
        // Date was changed, include new value
        apiData.enddate =
          typeof rowData?.enddate === "string"
            ? rowData?.enddate
            : rowData?.enddate?.toDate();
      }
      if (rowData.total_count !== undefined)
        apiData.total_count = rowData.total_count
          ? +rowData.total_count
          : undefined;
      // Only include product if it's explicitly set (not undefined)
      if (rowData.product !== undefined) {
        // Handle both string and number product values
        const productId =
          typeof rowData.product === "string"
            ? parseInt(rowData.product, 10)
            : rowData.product;
        apiData.product = productId && !isNaN(productId) ? productId : null;
      }
      if (rowData.description !== undefined)
        apiData.description = rowData.description;
      if (rowData.user_message !== undefined)
        apiData.user_message = rowData.user_message;
      if (rowData.end_message !== undefined)
        apiData.end_message = rowData.end_message;

      // Add amount or percent based on discount_type (only if changed)
      const discountType = apiData.discount_type ?? oldData.discount_type ?? 1;
      if (rowData.amount !== undefined) {
        if (discountType === 1) {
          apiData.amount = rowData.amount ? +rowData.amount : undefined;
          apiData.percent = undefined;
        }
      }
      if (rowData.percent !== undefined) {
        if (discountType === 2) {
          apiData.percent = rowData.percent ? +rowData.percent : undefined;
          apiData.amount = undefined;
        }
      }

      api
        .put(`/discounts/${oldData.id}`, { ...apiData, product: {id: +rowData.productId} })
        .then(() => {
          message.success("کد تخفیف با موفقیت به‌روزرسانی شد");
          ClearLoading();
          loadData();
        })
        .catch((err) => {
          ClearLoading();
          console.error("Update error:", err);
          editError();
        });
    }
  };

  return (
    <div>
      <DataTable
        header={{
          title: "کدهای تخفیف",
          avatar: { icon: <PercentageOutlined />, size: "large" },
        }}
        editable
        keepPageOnSave
        hideComment
        hideErrorReport
        path="/discounts"
        columns={columns}
        dataSource={data}
        setDataSource={setData}
        onSave={onSave}
        reload={loadData}
        permissionsPrefix="external_discount"
        recordDefault={{
          discount_type: 1,
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDiscount);
